'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './app-config.routes';

export class AppConfigEditorComponent {

  constructor($uibModal, SettingsService, dialogs, $scope, prompt, Config, $window) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.SettingsService = SettingsService;
    this.$scope = $scope;
    this.prompt = prompt;
    this.$window = $window;



    SettingsService.getByName({name: 'config.app'}, setting => {
      this.setting = setting;
      this.appConfig = setting.data;

      this.general = this.appConfig.moduleConfig.general;
      this.document = this.appConfig.moduleConfig.document;

      this.documentTypeSchema= {
        type: "object",
        properties: {
          documentType: {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          defaultDocumentUploadType: {
            "type": "string",
            "enum": this.document.documentType
          }
        }
      };
      this.documentTypeForm = [{
        key: "documentType",
        title:"",
        add: "Add Document Type",
        items: [{
          title: "",
          key: "documentType[]"
        }]
      },{
        title: "Default Upload Type",
        key: "defaultDocumentUploadType"
      }];
    });

    this.config = {
      'frontpage': ['classic', "fullslider", "video", "pageonly"]
    };

    this.linkCategories = [
      {
        "name": "General", "description": "",
        "id": "general",
        "children": [
          { "id": "general.client", "name" : "Client Settings", "description" : "", "children" : [] },
        ]
      },
      {
        "name": "Document", "description": "",
        "children": [
          { "id": "document.types", "name" : "Document Types", "description" : "", "children" : [] },
        ]
      },
      {
        "name" : "Directories", "description":"Lorem ipsum",
        "id": "directory",
        "children" : [
          { "id": "directory.numbers", "name" : "Important Numbers", "description" : "A list with important numbers", "children" : [] },
          { "id": "directory.users", "name" : "User Directory", "description" : "A directory with all the registered users and their profiles", "children" : [] },
          { "id": "directory.businesses", "name" : "Business Directory", "description" : "A directory with all the resident business profiles which have been created by the users", "children" : [] },
          { "id": "directory.vendors", "name" : "Preferred Vendors List", "description" : "An admin created and managed directory of vendors", "children" : [] },
          { "id": "directory.directory", "name" : "Generic Person Directory", "description" : "An directory with name, function, a profile image, contact information and a short description. Possible use-cases include Board of Directories and Staff.", "children" : [] }
        ]
      },
      {
        "name": "Calendar", "description": "",
        "children": [

        ]
      },
      {
        "name": "Gallery", "description": "",
        "children": [

        ]
      },
      {
        "name": "Forum", "description": "",
        "children": [

        ]
      },
      {
        "name": "News", "description": "",
        "children": [

        ]
      },
      {
        "name": "Bulletin Board", "description": "",
        "children": [

        ]
      },
      {
        "name": "SignUp", "description": "",
        "children": [

        ]
      },
      {
        "name": "Profile", "description": "",
        "children": [

        ]
      },
      {
        "name": "Mailblast", "description": "",
        "children": [

        ]
      },
      {
        "name": "Reservation", "description": "",
        "children": [

        ]
      }

    ];
  }

  openMenuEntryEditor(menuEntry) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      size: 'lg',
      component: 'menuEntryEdit',
      resolve: {
        config: function() {
          return {
            public: that.public,
            menuEntry: menuEntry
          }
        }
      }
    });

    modalInstance.result.then(
      function () {
       //todo: ddd

      },
      function () { /* cancel */ }
    );

  }

  save() {
    this.setting.data = this.appConfig;
    this.SettingsService.update({id: this.setting._id}, this.setting, _ => {
      this.dialogs.notify("Success","The application config has been updated successfully");
      //then:  this.$window.location.reload();
    }, err => {
      console.log('There has been an error.')
    });
  }
}

export default angular.module('conduu.appConfigEditor', [uiRouter])
  .config(routes)
  .component('appConfigEditor', {
    template: require('./app-config.html'),
    controller: AppConfigEditorComponent,
    controllerAs: 'ctrl',
    bindings: {
      public: '<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/app-config/app-config.component.js